import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLADProcessorListEffect } from '../Claims/LossAndDamage/LossAndDamageClaimsEffects';
import { setLADClaimsProcessorList } from '../common/CommonActions';

const useLADProcessorList = () => {
  const [list, setList] = useState(undefined);
  const { LADProcessor } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: fix this
  useEffect(() => {
    if (LADProcessor.success) {
      setList(LADProcessor.data);
    } else {
      getList();
    }
  }, [LADProcessor]);

  const getList = async () => {
    try {
      dispatch(setLADClaimsProcessorList({ data: [], success: true }));
      const { data } = await getLADProcessorListEffect();
      setList(data);
      dispatch(setLADClaimsProcessorList({ data, success: true }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useLADProcessorList;
